import { combineReducers } from "redux"

import addFeed from "./add-feed-presentation-reducer"
import authentication from "./authentication-presentation-reducer"
import clusters from "./cluster-presentation-reducer"
import communities from "./community-presentation-reducer"
import dashboard from "./dashboard-presentation-reducer"
import evidence from "./evidence-presentation-reducer"
import feed from "./feed-presentation-reducer"
import insightAreas from "./insight-areas/insight-area-presentation-reducer"
import keyIssues from "./key-issue-presentation-reducer"
import notifications from "./notification-presentation-reducer"
import roles from "./role-presentation-reducer"
import sources from "./source-presentation-reducer"
import stakeholders from "./stakeholder-presentation-reducer"
import studio from "./studio-presentation-reducer"
import studioBriefing from "./studio-briefing-presentation-reducer"
import studioImage from "./studio-image-presentation-reducer"
import studioCreateDimension from "./studio-create-dimension-presentation-reducer"
import studioEdit from "./studio-edit-presentation-reducer"
import users from "./user-presentation-reducer"

export default combineReducers({
    addFeed,
    authentication,
    clusters,
    communities,
    dashboard,
    evidence,
    feed,
    insightAreas,
    keyIssues,
    notifications,
    roles,
    sources,
    stakeholders,
    studio,
    studioBriefing,
    studioImage,
    studioCreateDimension,
    studioEdit,
    users,
})
